import React, { forwardRef } from 'react';
import { PropTypes } from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';

import { ArrowRightCircled } from 'src/assets/icons/ArrowRightCircled';
import { ArrowLeftCircled } from 'src/assets/icons/ArrowLeftCircled';

export const TabScrollButton = forwardRef((props, ref) => {
  const { direction, ...other } = props;

  return (
    <ButtonBase
      component="div"
      ref={ref}
      style={{ opacity: other.disabled ? 0 : 1 }}
      {...other}
    >
      {direction === 'left' ? <ArrowLeftCircled /> : <ArrowRightCircled />}
    </ButtonBase>
  );
});

TabScrollButton.propTypes = {
  direction: PropTypes.string,
};

TabScrollButton.defaultProps = {
  direction: null,
};
